import { configureStore } from "@reduxjs/toolkit";
import moveInTenantSliceReducer from "./moveInTenantSlice";
import tenantsSliceReducer from "./tenantsSlice";
import usersSliceReducer from "./usersSlice";
import chatUserSlice from "./chatUserSlice";

export const store = configureStore({
    reducer:{
        moveInTenant: moveInTenantSliceReducer,
        tenants: tenantsSliceReducer,
        user: usersSliceReducer,
        chatUser: chatUserSlice
    }
});